// removed by extract-text-webpack-plugin
module.exports = {"tabs-container":"Ihg-s_jjqrEA62GT3mqq-","tabs-header-container":"_3s5JJvB-M3U4vQhr89aZZB","tab-header":"_1l_av_OP7gAyltY0pvx3C4","tabs-content":"qWpjopl_cpI8dIuspitPf","tabs-container-vertical":"_1IPWt9k9qp41IwmA1KFvCm","tabs-header-container-vertical":"_1feu7xMXCVKgpzPSZIas8m","tab-header-vertical":"_3MyWxkbXFoU72FbzfgV9wK","tabs-content-vertical":"_2j0NHnza2nm9H6vrrNE_5a","user-info":"_3LZJfQXqc-ixkOoQFaGAiK","referralLink":"_2MnHlAk-98VmcW1gaiFLH0","clipIcons":"_3kHIruS4I9jQs2dpJ50Jzt","spin":"-hBQ5eVuBPy7WxXe2zG0g"};


//////////////////
// WEBPACK FOOTER
// ./src/topic/UserInfo/views/styles.scss
// module id = 1661
// module chunks = 18